import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

// eod_spread_setting is a singleton row (id 1, seeded by the ordit migration)
export const EOD_SPREAD_SETTING_ID = 1

class EodSpreadSettingApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/eod-spread-settings'
    }
}

export default new EodSpreadSettingApiClient()
